import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EltType, Attr } from "../pandoc";
import { OutDesignSelectorEventDispatcherElement } from "./SelectorEventDispatcher";
import { Selector } from "../rules";

@customElement("od-meta")
export class OutDesignMetaElement extends OutDesignSelectorEventDispatcherElement {
  @property() type: EltType;
  @property() attr?: Attr;
  @property() data?: Record<string, string | number>;

  static styles = css`
    span:hover {
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
    }
  `;

  get identifier(): string | undefined {
    return this.attr?.[0];
  }

  get classes(): Array<string> | undefined {
    return this.attr?.[1];
  }

  get kvs(): Array<[string, any]> | undefined {
    return this.attr?.[2];
  }

  get level(): string | number | undefined {
    return this.data?.level;
  }

  private handleEmission(payload: Array<Partial<Selector>>, temp: boolean, shiftKeyPressed: boolean): void {
    const mode: string = shiftKeyPressed ? "append": "replace";

    // This is for removing the highlighted text.
    // Another solution would be to use another key.
    if(shiftKeyPressed && !temp) {
      if (window.getSelection) {window.getSelection()?.removeAllRanges();}
    }

    if (!temp) {
      this.emit(payload, mode)
    } else {
      this.emitTemp(payload, mode)
    }
  }

  render() {
    return html`
      <span
        @click=${(e: MouseEvent) => this.handleEmission([{ type: this.type }], false, e.shiftKey)}
        @mouseenter=${(e: MouseEvent) => this.handleEmission([{ type: this.type }], true, e.shiftKey)}
        @mouseleave=${(e: MouseEvent) => this.handleEmission([{}], true, e.shiftKey)}
      >${this.type}</span>

      ${this.level
        ? html`
            <span>${this.level}</span>
          `
        : ""}

      ${this.identifier
        ? html`
            <span
              @click=${(e: MouseEvent) => this.handleEmission([{ id: this.identifier }], false, e.shiftKey)}
              @mouseenter=${(e: MouseEvent) => this.handleEmission([{ id: this.identifier }], true, e.shiftKey)}
              @mouseleave=${(e: MouseEvent) => this.handleEmission([{}], true, e.shiftKey)}
            >#${this.identifier}</span>
          `
        : ""}

      ${this.classes
        ? this.classes.map(
          (cls) => html`
            <span
              @click=${(e: MouseEvent) => this.handleEmission([{ classes: [cls] }], false, e.shiftKey)}
              @mouseenter=${(e: MouseEvent) => this.handleEmission([{ classes: [cls] }], true, e.shiftKey)}
              @mouseleave=${(e: MouseEvent) => this.handleEmission([{}], true, e.shiftKey)}
            >.${cls}</span>
          `
        )
        : ""}
    `;
  }
}